// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","overlayContainer":"_2Osd7","inline":"_3azBB","title":"_1xLCh","description":"PAVE0","button":"z_7Hj","modal":"_2Siey"};